import { CLOVER_PATH } from "../../api/Api.consts";

export function initOAuth(
  clientId: string,
  merchantId: string | null = null
) {
  window.location.replace(CLOVER_PATH.OAUTH(clientId, merchantId));
}
